import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check, Globe, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { COURSES } from '../i18n';
import { cn } from '../lib/utils';

const CourseSelector = ({ selectedCourse, onSelectCourse, onConfirm, showConfirmButton = true }) => {
  const { t } = useTranslation();

  const courseList = Object.values(COURSES);

  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
          <Globe className="w-8 h-8 text-primary" />
        </div>
        <h2 className="text-2xl font-bold">{t('courses.selectCourse')}</h2>
        <p className="text-muted-foreground">{t('courses.selectCourseDesc')}</p>
      </div>

      <div className="grid gap-3">
        {courseList.map((course) => {
          const [sourceFlag, targetFlag] = course.flag.split(' → ');
          return (
            <button
              key={course.id}
              onClick={() => onSelectCourse(course.id)}
              data-testid={`course-option-${course.id}`}
              className={cn(
                'w-full p-4 rounded-xl border-2 text-left transition-all',
                'hover:border-primary/50 hover:bg-primary/5',
                selectedCourse === course.id
                  ? 'border-primary bg-primary/10'
                  : 'border-border bg-card'
              )}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  {/* Large Flags Display */}
                  <div className="flex items-center gap-2">
                    <span className="text-3xl">{sourceFlag}</span>
                    <span className="text-lg text-muted-foreground font-bold">→</span>
                    <span className="text-3xl">{targetFlag}</span>
                  </div>
                  <div className="border-l border-border pl-4">
                    <p className="font-semibold">{course.nameNative}</p>
                    <p className="text-sm text-muted-foreground">{course.descriptionNative}</p>
                  </div>
                </div>
                {selectedCourse === course.id && (
                  <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center shrink-0">
                    <Check className="w-4 h-4 text-primary-foreground" />
                  </div>
                )}
              </div>
            </button>
          );
        })}
      </div>

      {showConfirmButton && selectedCourse && (
        <Button
          onClick={onConfirm}
          className="w-full btn-primary-gradient"
          size="lg"
          data-testid="confirm-course-btn"
        >
          {t('courses.startLearning')}
          <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      )}
    </div>
  );
};

export default CourseSelector;
